module.exports = __webpack_public_path__ + "img/i_nav_my_new_on.825b287f.svg";